import(/* webpackMode: "eager" */ "/app/apps/location-app-router/src/app/global-error.tsx");
